import { LOAD_TRIGGERS_SUCCESS, UPDATE_TRIGGER_FIELD, LOAD_TRIGGER_BY_ID, LOAD_TRIGGER_BY_ID_SUCCESS, LOAD_TRIGGERS, UPDATE_TRIGGER_SUCCESS, CREATE_TRIGGER_SUCCESS, Trigger, REMOVE_TRIGGER_BY_ID, REMOVE_TRIGGER_BY_ID_SUCCESS,  SORT_TRIGGERS, SAVE_TRIGGER, DELETE_TRIGGER, DELETE_TRIGGER_SUCCESS, FETCH_TRIGGER_FIRE_COUNT_REQUEST, FETCH_TRIGGER_FIRE_COUNT_SUCCESS, FETCH_TRIGGER_FIRE_COUNT_FAILURE} from "./types";
import store from '../../store';
import axios from '../../lib/axios';
import config from '../../config/app-config.json';

export const emptyTrigger = () => {
    return {
        type: CREATE_TRIGGER_SUCCESS,
        payload: null
    }
}

export const updateTriggerField = (field, value) => {
    return {
        type: UPDATE_TRIGGER_FIELD,
        payload: { field, value }
    }
}

export const deleteTrigger = id => {
    return (dispatch: any) => {
        dispatch({
            type: DELETE_TRIGGER,
            payload: null
        })
        axios.delete(`${config.serviceUrl}/trigger/${id}`).then((response) => {
            dispatch({
                type: DELETE_TRIGGER_SUCCESS,
                payload: response.data
            })
        })
    }
}

export const loadTriggers = () => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_TRIGGERS,
            payload: null
        })
        axios.get(`${config.serviceUrl}/triggers/`).then((response) => {
            dispatch({
                type: LOAD_TRIGGERS_SUCCESS,
                payload: response.data.data
            })
        })
    }
}

export const loadTriggerById = id => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_TRIGGER_BY_ID,
            payload: null
        })
        axios.get(`${config.serviceUrl}/clients/${id}`).then((response) => {
            dispatch({
                type: LOAD_TRIGGER_BY_ID_SUCCESS,
                payload: response.data.data[0]
            })
        })
    }
  }

  export const fetchTriggerFireCount = (triggerId: number) => {
    return (dispatch: any) => {
        console.log('[ACTION] Fetching trigger fire count for triggerId:', triggerId);
        
        dispatch({
            type: FETCH_TRIGGER_FIRE_COUNT_REQUEST,
            payload: null
        });
        
        try {
            console.log('[ACTION] Making API call to:', `${config.serviceUrl}/triggers/${triggerId}/fire-count`);
            
            axios.get(`${config.serviceUrl}/triggers/${triggerId}/fire-count`).then((response) => {
                console.log('[ACTION] API response:', response.data);
                
                const count = response.data.data.count || 0;
                console.log('[ACTION] Extracted count:', count);
                
                dispatch({
                    type: FETCH_TRIGGER_FIRE_COUNT_SUCCESS,
                    payload: { 
                        triggerId, 
                        count 
                    }
                });
                
                return count;
            }).catch((error) => {
                console.error('[ACTION] Error fetching trigger fire count:', error);
                
                dispatch({
                    type: FETCH_TRIGGER_FIRE_COUNT_FAILURE,
                    payload: { error: error.message }
                });
                
                return 0;
            });
        } catch (error) {
            console.error('[ACTION] Error before API call:', error);
            
            dispatch({
                type: FETCH_TRIGGER_FIRE_COUNT_FAILURE,
                payload: { error: error instanceof Error ? error.message : 'Unknown error' }
            });
            
            return 0;
        }
    };
}

export const  loadTriggerById2 = data => {
    return (dispatch: any) => {
        dispatch({
            type: LOAD_TRIGGER_BY_ID_SUCCESS,
            payload: data
        })
    }
}

export const saveTrigger = (trigger: Trigger, history: any) => {
    return (dispatch: any) => {
        if(trigger.id) {
            dispatch({
                type: SAVE_TRIGGER,
                payload: null
            })
            axios.put(`${config.serviceUrl}/trigger/${trigger.id}`, trigger).then((response) => {
                dispatch({
                    type: UPDATE_TRIGGER_SUCCESS,
                    payload: response
                })
                dispatch({
                    type: LOAD_TRIGGERS,
                    payload: null
                })
                axios.get(`${config.serviceUrl}/triggers/`).then((response) => {
                    dispatch({
                        type: LOAD_TRIGGERS_SUCCESS,
                        payload: response.data.data
                    })
                })
            })
        } else {
            dispatch({
                type: SAVE_TRIGGER,
                payload: null
            })
            axios.post(`${config.serviceUrl}/trigger`, trigger).then((response: any) => {
                dispatch({
                    type: CREATE_TRIGGER_SUCCESS,
                    payload: response
                })
                dispatch({
                    type: LOAD_TRIGGERS,
                    payload: null
                })
                axios.get(`${config.serviceUrl}/triggers/`).then((response) => {
                    dispatch({
                        type: LOAD_TRIGGERS_SUCCESS,
                        payload: response.data.data
                    })
                })
            })
        }
    }
}